"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLatestVersions = void 0;
const react_1 = require("react");
const useAuth_1 = require("./useAuth");
const amplifyBootstrap_1 = require("../utils/amplifyBootstrap");
// Fetches the latest available firmware + web-hub versions (CI-published S3
// markers, read server-side by GET /latest-versions) so callers can flag
// whether a hub is up to date. Best-effort: on failure `latest` stays null and
// the UI simply shows no indicator.
const useLatestVersions = () => {
    const [latest, setLatest] = (0, react_1.useState)(null);
    const [loading, setLoading] = (0, react_1.useState)(false);
    const { currentSession } = (0, useAuth_1.useAuth)();
    const refetch = (0, react_1.useCallback)(async () => {
        setLoading(true);
        try {
            const session = await currentSession();
            const idToken = session.tokens?.idToken?.toString();
            const result = await amplifyBootstrap_1.API.get('/latest-versions', {
                headers: idToken ? { Authorization: `Bearer ${idToken}` } : {},
            });
            setLatest(result);
        }
        catch {
            // best-effort — indicators just won't render
        }
        finally {
            setLoading(false);
        }
    }, [currentSession]);
    (0, react_1.useEffect)(() => {
        refetch();
    }, [refetch]);
    return { latest, loading, refetch };
};
exports.useLatestVersions = useLatestVersions;
